import mustache from "mustache";
import { IConnectRender } from "../../shared/components/definitions/IConnectRender";
import { AplicacionesConfiguracionModal } from "../../shared/components/modulos/configuracion/aplicaciones/modal/AplicacionesConfiguracionModal";
import { GanaderiaConfiguracionModal } from "../../shared/components/modulos/configuracion/ganaderia/modal/GanaderiaConfiguracionModal";
import { MonitoreoConfiguracionModal } from "../../shared/components/modulos/configuracion/monitoreo/modal/MonitoreoConfiguracionModal";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { ClienteFincaBaseResponse } from "../../shared/modulos/terceros/response/ClienteFincaBaseResponse";
import { ClienteFincaLoteResponse } from "../../shared/modulos/terceros/response/ClienteFincaLoteResponse";
import { fx_createLoteGrpcService } from "../../shared/modulos/terceros/services/LoteGrpcService";
import { fx_createFincaClimaHorarioGrpcService } from "../../shared/modulos/clima/services/FincaClimaHorarioGrpcService";
import { LoginAuthResponse } from "../response/LoginAuthResponse";
import template from "./modulesTemplate.html";

mustache.parse(template);

export const APP_RUTA_APLICACIONES = "/aplicaciones";
export const APP_RUTA_FERTILIZACION = "/fertilizacion";
export const APP_RUTA_SATELITE = "/satelite";
export const APP_RUTA_MONITOREO_BROCA = "/monitoreo/broca";
/** Dashboard histórico de monitoreo. **Sin ítem de menú**: se llega desde el
 *  botón "Dashboard" del pie del sidebar del mapa. La ruta sigue registrada en
 *  `ClienteAsideMenuRender.getPage`; lo que se quitó es la entrada del menú. */
export const APP_RUTA_MONITOREO_ANALISIS = "/monitoreo/analisis";
/** Vista de sesión: mapa con el semáforo por plaga. Es la **única** entrada de
 *  menú del módulo: desde acá se llega al dashboard y a los informes. */
export const APP_RUTA_MONITOREO_PLAGAS = "/monitoreo/plagas";
/** Informe semanal (o de un día) imprimible. **Sin ítem de menú**: se llega
 *  desde el botón de informe de una semana del sidebar del mapa y desde
 *  "Ver informes" del dashboard. */
export const APP_RUTA_MONITOREO_REPORTE = "/monitoreo/reporte";
export const APP_RUTA_PESAJE_GANADERIA_DASHBOARD = "/pesaje/ganaderia/dashboard";
export const APP_RUTA_PESAJE_GANADERIA_COMPRAS = "/pesaje/ganaderia/compras";
export const APP_RUTA_PESAJE_GANADERIA_VENTAS = "/pesaje/ganaderia/ventas";
export const APP_RUTA_PESAJE_GANADERIA_ROTACION_PESAJE_VETERINARIA =
  "/pesaje/ganaderia/rotacion-pesaje-veterinaria";
export const APP_RUTA_TAREAS = "/tareas";
export const APP_RUTA_CLIMA_CURRENT = "/clima/current";
export const APP_RUTA_CLIMA_FORECAST = "/clima/forecast";
/** Vista del agricultor sobre sus proyectos (solo lectura, mockup PM_C_Agricultor). */
export const APP_RUTA_MIS_PROYECTOS = "/mis-proyectos";

export class ClienteModulesComponent implements IConnectRender {
  private readonly _loginResponse: LoginAuthResponse;
  private readonly _finca: ClienteFincaBaseResponse;

  constructor(
    loginResponse: LoginAuthResponse,
    finca: ClienteFincaBaseResponse,
  ) {
    this._loginResponse = loginResponse;
    this._finca = finca;
  }

  render(): string {
    return mustache.render(template, {
      rutaAplicaciones: APP_RUTA_APLICACIONES,
      rutaFertilizacion: APP_RUTA_FERTILIZACION,
      rutaSatelite: APP_RUTA_SATELITE,
      isAgricultura: this._finca.isAgricultura,
      isSextante: document.body.dataset.brand === "sextante",
      rutaMonitoreoBroca: APP_RUTA_MONITOREO_BROCA,
      rutaMonitoreoPlagas: APP_RUTA_MONITOREO_PLAGAS,
      isGanaderia: this._finca.isGanaderia,
      rutaPesajeGanaderiaDashboard: APP_RUTA_PESAJE_GANADERIA_DASHBOARD,
      rutaPesajeGanaderiaCompras: APP_RUTA_PESAJE_GANADERIA_COMPRAS,
      rutaPesajeGanaderiaVentas: APP_RUTA_PESAJE_GANADERIA_VENTAS,
      rutaPesajeGanaderiaRotacionPesajeVeterinaria:
        APP_RUTA_PESAJE_GANADERIA_ROTACION_PESAJE_VETERINARIA,
      rutaTareas: APP_RUTA_TAREAS,
      isDemoPlataforma: this._loginResponse.isDemoPlataforma,
      rutaClimaCurrent: APP_RUTA_CLIMA_CURRENT,
      rutaClimaForecast: APP_RUTA_CLIMA_FORECAST,
    });
  }

  connect(): void {
    if (this._disposed) return;

    fx_createLoteGrpcService(this._finca.id)
      .getListAsync()
      .then((lotes) => {
        this._connect(lotes);
      })
      .catch();

    // Independiente de los lotes: si no es demo (ahí ya se desactiva por
    // template, sin pedir nada), se pide el horario de clima solo para saber
    // si esta finca tiene datos -reusa la misma caché de
    // FincaClimaHorarioGrpcService que ya usan las páginas de Clima, así que
    // para una finca con datos esto resuelve de IndexedDB, sin red-.
    if (this._loginResponse.isDemoPlataforma == false) {
      fx_createFincaClimaHorarioGrpcService(this._finca.id)
        .getListAsync()
        .then((items) => {
          if (this._disposed) return;
          this._setDisabled(
            "navFincaGroupClima",
            items.length === 0,
            "Clima: todavía no hay datos climáticos para esta finca.",
          );
        })
        .catch(() => {});
    }
  }

  dispose(): void {
    this._disposed = true;
  }

  /** Sincroniza el resaltado de los módulos con la ruta activa: despinta todo
   *  y marca el ítem cuyo `data-page` coincide (+ su grupo padre). Rutas sin
   *  ítem (p. ej. `/finca`) dejan el menú sin resaltado. */
  syncActive(route: string): void {
    if (this._disposed) return;
    const navModulos = document.getElementById("navModulos");
    if (!navModulos) return;

    navModulos.querySelectorAll(".active").forEach((el) => {
      el.classList.remove("active");
    });

    const link = navModulos.querySelector<HTMLElement>(
      `[data-page="${route}"]`,
    );
    if (!link) return;
    link.classList.add("active");
    const parent = link.dataset.parent;
    if (parent) document.getElementById(parent)?.classList.add("active");
  }

  private _disposed: boolean = false;

  private _connect = (lotes: ClienteFincaLoteResponse[]) => {
    if (this._disposed) return;

    const navModulos = document.getElementById("navModulos");
    if (!navModulos) return;

    const fx_runQuerySelectorAll = (
      querySelectorAll: string,
      handler: (link: HTMLElement) => void,
    ) => {
      if (this._disposed) return;

      navModulos
        .querySelectorAll<HTMLDivElement>(querySelectorAll)
        .forEach(handler);
    };

    const queryDataPage = "div[data-page]";
    const queryDataTarget = "div[data-target]";

    fx_runQuerySelectorAll(queryDataPage, (link) => {
      const page = link.dataset.page;
      if (!page) return;

      link.addEventListener("click", () => {
        if (!link.isConnected) return;
        // El estado "desactivado" puede llegar después del bind (ej. Broca/
        // Plagas se marcan recién cuando responden los lotes), así que se
        // revisa el atributo al momento del click, no al conectar.
        if (link.dataset.disabled === "true") {
          this._avisarDesactivado(link);
          return;
        }
        // El resaltado lo sincroniza syncActive (vía onNavigate del aside):
        // una sola fuente de verdad para clicks y navegación programática.
        serviceProvider.getLayoutService().navigate(page);
      });
    });

    // Ítems desactivados sin navegación propia (ej. Clima en plan demo): el
    // click no navega, solo repite la explicación del tooltip como toast
    // -para usuarios táctiles, que no tienen hover-.
    fx_runQuerySelectorAll('div[data-disabled="true"]:not([data-page])', (link) => {
      link.addEventListener("click", () => {
        if (!link.isConnected) return;
        this._avisarDesactivado(link);
      });
    });

    // Ítem "Configuración" de ganadería: abre el modal cancelable (no navega,
    // así que cierra el menú lateral a mano — navigate() no lo hace por él).
    fx_runQuerySelectorAll('div[data-action="ganaderia-config"]', (link) => {
      link.addEventListener("click", () => {
        if (!link.isConnected) return;
        document.getElementById("sidebarWrapper")?.classList.remove("open");
        const finca = serviceProvider.getFincaSelectedService().getRequired();
        new GanaderiaConfiguracionModal(finca, true).init();
      });
    });

    // Ítem "Configuración" de monitoreo: mismo trato que el de ganadería —
    // abre un modal en vez de navegar, así que cierra el menú a mano.
    fx_runQuerySelectorAll('div[data-action="monitoreo-config"]', (link) => {
      link.addEventListener("click", () => {
        if (!link.isConnected) return;
        document.getElementById("sidebarWrapper")?.classList.remove("open");
        new MonitoreoConfiguracionModal().init();
      });
    });

    // Ítem "Configuración" de aplicaciones: los recipientes (canecas, tanques)
    // con los que se mide una aplicación manual. Mismo trato que los otros dos.
    fx_runQuerySelectorAll('div[data-action="aplicaciones-config"]', (link) => {
      link.addEventListener("click", () => {
        if (!link.isConnected) return;
        document.getElementById("sidebarWrapper")?.classList.remove("open");
        new AplicacionesConfiguracionModal().init();
      });
    });

    if (this._finca.isAgricultura) {
      // Broca = café. Plagas = el resto de los cultivos con monitoreo
      // (cítricos, aguacate Hass, mango, macadamia, guanábana, papa). Son dos
      // grupos distintos del menú y una finca puede tener los dos a la vez.
      // El grupo "Monitoreo" y sus ítems ya están en el DOM (el template los
      // pone según isAgricultura/isSextante) — acá solo se decide si cada
      // ítem queda activo o desactivado-con-explicación según los lotes.
      const hasMonitoreoBroca = lotes.some((r) => r.cultivo?.isMonitoreoCafe);
      const hasMonitoreoPlagas = lotes.some((r) => (r.cultivo?.cantidadPlagas ?? 0) > 0);

      this._setDisabled(
        "itemMonitoreoBroca",
        !hasMonitoreoBroca,
        "Monitoreo de broca: esta finca no tiene lotes con cultivo café.",
      );
      // El ítem de Plagas ni siquiera está en el DOM si la marca no es
      // Sextante (gate por template, decisión de producto) — de ahí el
      // getElementById en vez de "!": puede no existir.
      if (document.getElementById("itemMonitoreoPlagas")) {
        this._setDisabled(
          "itemMonitoreoPlagas",
          !hasMonitoreoPlagas,
          "Monitoreo de plagas: esta finca no tiene lotes con cultivo cítricos, aguacate, mango, macadamia, guanábana o papa.",
        );
      }
    }

    fx_runQuerySelectorAll(queryDataTarget, (dropdown) => {
      const dataTarget = dropdown.dataset.target;
      if (!dataTarget) return;
      dropdown.addEventListener("click", () => {
        if (!dropdown.isConnected) return;
        // Mismo criterio que el listener de data-page: el estado desactivado
        // puede llegar después del bind (ej. Clima recién sabe si hay datos
        // cuando responde el horario), así que se revisa al momento del
        // click. Un grupo desactivado no se abre -no hay nada útil adentro-,
        // solo avisa por qué.
        if (dropdown.dataset.disabled === "true") {
          this._avisarDesactivado(dropdown);
          return;
        }

        const target = document.getElementById(dataTarget);
        if (!target) return;

        target.classList.toggle("open");
      });
    });
  };

  /** Marca (o desmarca) un ítem del menú como "desactivado informativo":
   *  clase `disabled-info` (ver mainLayout.css — a propósito NO usa
   *  `pointer-events: none` como `.disabled`, porque este ítem sigue
   *  necesitando click/hover para el tooltip y el toast) + `data-disabled`
   *  (lo revisa el listener de click antes de navegar) + `title` nativo. */
  private _setDisabled(elementId: string, disabled: boolean, motivo: string): void {
    const el = document.getElementById(elementId);
    if (!el) return;

    el.classList.toggle("disabled-info", disabled);
    if (disabled) {
      el.dataset.disabled = "true";
      el.title = motivo;
    } else {
      delete el.dataset.disabled;
      el.removeAttribute("title");
    }
  }

  /** Toast con el motivo (el `title` del propio ítem) — para quien hizo click
   *  sin pasar por el hover, tipicamente en touch. */
  private _avisarDesactivado(link: HTMLElement): void {
    const motivo = link.getAttribute("title");
    if (!motivo) return;
    serviceProvider.getErrorService().addWarning("No disponible", motivo);
  }
}
